var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.835847 4.57617H19.165C19.1518 2.63552 19.0561 1.5761 18.3616 0.881628C17.5562 0.0761719 16.2598 0.0761719 13.6671 0.0761719H6.33374C3.74102 0.0761719 2.44465 0.0761719 1.6392 0.881628C0.944721 1.5761 0.849032 2.63552 0.835847 4.57617ZM19.1671 6.57616V8.32617C19.1671 10.9189 19.1671 12.2153 18.3616 13.0207C17.5562 13.8262 16.2598 13.8262 13.6671 13.8262H6.33374C3.74102 13.8262 2.44465 13.8262 1.6392 13.0207C0.83374 12.2153 0.83374 10.9189 0.83374 8.32617V6.57617H19.1667L19.1671 6.57616ZM5.52808 9.16504L5.42651 9.15918H5.41675C4.86472 9.15935 4.41692 9.60715 4.41675 10.1592C4.41675 10.7114 4.86461 11.159 5.41675 11.1592H5.42651L5.52808 11.1543C6.03252 11.1033 6.42651 10.6771 6.42651 10.1592C6.42635 9.64143 6.0324 9.21607 5.52808 9.16504Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.2ab9d19394808abec945aeb563dc7eac.svg";
export { ForwardRef as ReactComponent };